import { Button } from "../../../Common/AbstractComponents/Button";

export class InfoPopup {
    constructor({ page }) {
        this.$page = page;
        this.$popup = $('#news_popup_info');

        this.$popupBtn = this.$popup.find('.btn');

        this._btn = new Button({
            button: this.$popupBtn,
            onClick: this._hide.bind(this),
        })
    }

    show({ title, message }) {
        this.$popup.find('.title').html(message);
        $('html').addClass('_open_bus_popup');
        $('.news_overlay').addClass('_active');
        $(this.$popup).addClass('_active');
    }

    _hide() {
        $('html').removeClass('_open_bus_popup');
        $('.news_overlay').removeClass('_active');
        $('.news_popup').removeClass('_active');
        $('.popup_places').removeClass('_active');
    }
}